import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

gsap.to(".scroll-down", {
    scrollTrigger: {
        trigger: "#top",
        start: "60px top",
        // markers: true
    },
    opacity: 0,
});

import EmblaCarousel from "embla-carousel";
import { addDotBtnsAndClickHandlers } from "./EmblaCarouselDotButton";

// Generisk init for en embla-wrapper
function initEmblaCarousel(root, options, cfg = {}) {
    // root er .embla (eller .mina) wrapperen din
    const embla = EmblaCarousel(root, options);

    // Knapper scoped til denne instansen
    const prevBtn = root.querySelector(cfg.prevSelector || ".embla__prev");
    const nextBtn = root.querySelector(cfg.nextSelector || ".embla__next");

    if (prevBtn) prevBtn.addEventListener("click", () => embla.scrollPrev());
    if (nextBtn) nextBtn.addEventListener("click", () => embla.scrollNext());

    // Dots (valgfritt, hvis finnes)
    if (cfg.dotsSelector) {
        const dotsNode = root.querySelector(cfg.dotsSelector);
        if (dotsNode) addDotBtnsAndClickHandlers(embla, dotsNode);
    }

    // Nyttig logging per instans
    if (process.env.NODE_ENV !== "production") {
        // Litt beskyttelse i tilfelle tomme karuseller
        try {
            // eslint-disable-next-line no-console
            console.log("✅ Embla init:", embla, "slides:", embla.slideNodes().length, "snaps:", embla.scrollSnapList().length);
        } catch (_) {}
    }

    return embla;
}

// Init alle .embla på siden
document.querySelectorAll(".embla").forEach((emblaNode) => {
    initEmblaCarousel(
        emblaNode,
        {
            active: true,
            loop: false,
            align: "start",
            dragFree: false,
            containScroll: "trimSnaps",
            slides: "li.embla__card",
        },
        {
            prevSelector: ".embla__prev",
            nextSelector: ".embla__next",
            // dotsSelector: ".embla__dots" // (legg til hvis du har dots i dette oppsettet)
        }
    );
});

// Init alle .mina på siden (egen konfig/selektorer)
document.querySelectorAll(".mina").forEach((minaNode) => {
    initEmblaCarousel(
        minaNode,
        {
            active: true,
            loop: false,
            align: "start",
            dragFree: false,
            containScroll: "trimSnaps",
            slides: "li.mina__slide",
        },
        {
            prevSelector: ".mina__prev",
            nextSelector: ".mina__next",
            dotsSelector: ".mina__dots",
        }
    );
});
